import { useState } from 'react';
import { faqData } from '@/mocks/faqData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Everything you need to know about CSSBuy spreadsheets, from getting started to advanced shopping tips.
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span
                  className={`w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}